module.exports = __webpack_public_path__ + "img/Intro-Vector.b233ae9.png";